import { Link } from 'react-router-dom';
import { categories } from '@/mocks/arina';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.path ? `https://hashimoto-arina.com${item.path}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-400">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <span key={item.label} className="flex items-center gap-1.5">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-xs text-foreground-300"></i>
              )}
              {item.path && !isLast ? (
                <Link
                  to={item.path}
                  className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'text-foreground-700 font-medium' : ''}>
                  {item.label}
                </span>
              )}
            </span>
          );
        })}
      </nav>
    </>
  );
}

export function getCategoryBreadcrumb(slug: string): BreadcrumbItem[] {
  const category = categories.find((c) => c.slug === slug);
  return [
    { label: '首页', path: '/' },
    { label: category?.name || '分类', path: `/category/${slug}` },
  ];
}

export function getArticleBreadcrumb(article: { title: string; category: string }): BreadcrumbItem[] {
  const category = categories.find((c) => c.slug === article.category);
  return [
    { label: '首页', path: '/' },
    { label: category?.name || '分类', path: `/category/${article.category}` },
    { label: article.title },
  ];
}